
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns655b104734ab68b47b164d8eda1e79cben from './en.yaml'
            i18n.addResourceBundle('en', '655b104734ab68b47b164d8eda1e79cb', flattenObject(ns655b104734ab68b47b164d8eda1e79cben), true, true);
        
        export default '655b104734ab68b47b164d8eda1e79cb';
    